export const SCOPE_ALL = 'all'
export const SCOPE_ONLY_LISTED = 'only_listed'
